const map = {
	"./10tax_advisory.png": 312,
	"./1_image_1.png": 773,
	"./1_image_2.png": 798,
	"./1_image_3.png": 87,
	"./1financial_management.png": 242,
	"./2_image_1.png": 594,
	"./2_image_2.png": 777,
	"./2_image_3.png": 872,
	"./2financial_dvisory.png": 416,
	"./3_image_1.png": 759,
	"./3_image_2.png": 108,
	"./3_image_3.png": 373,
	"./3transaction_advisory.png": 339,
	"./4capital raising.png": 453,
	"./5advanced_cashflow_management.png": 545,
	"./6growth_centric_financial_strategy.png": 562,
	"./7technology_integration.png": 836,
	"./8risk_management.png": 101,
	"./9accounting_bookkeeping.png": 901,
	"./about_hero.png": 490,
	"./banner1.png": 673,
	"./banner2.png": 690,
	"./banner3.png": 547,
	"./naprev.png": 488,
	"./our_story.png": 866,
	"./services.png": 624,
	"./team.png": 539,
	"./team1.png": 954,
	"./team2.png": 937,
	"./team3.png": 224,
	"./who_we_are.png": 672
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;